import { Breadcrumbs } from '@/shared/ui-kit';
import { Path, PathLabels } from '@/shared/constants/links';
import { useRouter } from 'next/router';
import { useMediaQuery } from '@/shared/lib/use-media-query';
import { SalesPointsMap } from '@/widgets/sales-point-map';
import { PageMeta } from '@/shared/ui-kit/page-meta/page-meta';
import { apiEndpoints } from '@/shared/constants/links';
import { GetServerSidePropsContext } from 'next';
import { SalesPointEntity } from '@/store/api/sales-points/sales-points.type';
import { fetchEndpointData } from '@/shared/lib/request-api';
import styles from './sales-points.module.scss';

const breadCrumbsItems = [
  { title: PathLabels.main, href: Path.main },
  { title: 'Точки продаж', href: Path.pointsOfSale },
];

interface SalesPoint {
  dataFromServer: SalesPointEntity | undefined;
}

export default function SalesPoints({ dataFromServer }: SalesPoint) {
  const router = useRouter();
  const toSimPage = () => {
    router.push('/tariff-services/activation');
  };
  const { isMobile } = useMediaQuery();

  return (
    <>
      {/* <PageMeta title='Точки продаж' /> */}
      <div className={styles.wrapper}>
        <Breadcrumbs list={breadCrumbsItems} />
        <h1 className={styles.title}>Точки продаж</h1>
        <div className={styles.mapContainer}>
          <SalesPointsMap dataFromServer={dataFromServer} />
        </div>
        <div className={styles.simContainer} onClick={toSimPage}>
          <div className={styles.simInfo}>
            <span className={styles.simInfo__title}>SIM-карта, не выходя из дома</span>
            {!isMobile && (
              <div className={styles.simInfo__descBox}>
                Чтобы стать абонентом Волны, необязательно посещать точку продаж. Ты можешь оформить и активировать
                SIM-карту онлайн.
              </div>
            )}
            {isMobile && (
              <span className={styles.simInfo__descBox}>
                Ещё один способ стать абонентом «Волны», где и когда удобно. Необходимо лишь приобрести
                <br /> SIM-карту для онлайн активации.
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  let salesPoints: SalesPointEntity | undefined;

  try {
    salesPoints = await fetchEndpointData<SalesPointEntity>(apiEndpoints.salesPoints, {
      populate: '*',
      'pagination[limit]': 100,
    });
  } catch (error) {
    console.error(error);
  }
  return {
    props: {
      dataFromServer: salesPoints || null,
    },
  };
}
